<template>
  <header class="header">
      <div class="bg">
          <img class="img" :src="banner" alt="图片">
      </div>
      <img class="icon" :src="require('@/assets/images/icon/logo.png')" alt="">
      <ul class="nav">
          <li class="pointer" :class="{active: nav.href === activeNav}" v-for="nav in navList" :key="nav.code">
              <router-link :to="nav.href">{{nav.name}}</router-link>
          </li>
      </ul>
  </header>
</template>

<script>
export default {
    data(){
        return {
            activeNav: '',
            navList: [
                {
                    name: "首页",
                    code: 'home',
                    href: "/home"
                },
                {
                    name: "关于我们",
                    code: 'about',
                    href: "/about"
                },
                {
                    name: "新闻",
                    code: 'news',
                    href: "/news"
                },
                {
                    name: "联系我们",
                    code: 'contact',
                    href: "/contact"
                },
            ]
        }
    },
    props: {
        banner: {
            type: String,
            default:  require('@/assets/images/banner/home.png')
        }
    },
    mounted(){
        this.$nextTick(function(){
            this.init()
        })
    },
    methods: {
        init(){
            this.activeNav = this.$route.path
        }
    },
    watch: {
        $route(){
            this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    position: relative;
    width: 100%;
    overflow: hidden;
    .nav {
        position: absolute;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-left: 50%;
        width: 35%;
        font-size: 18px;
        color: rgba(255, 255, 255, 0.8);
        z-index: 2;
        & > li {
            box-sizing: border-box;
            padding: 25px 0 0;
            height: 58px;
            &:hover {
                border-bottom: 2px solid rgba(255, 255, 255, 0.8);
            }
            &.active {
                border-bottom: 2px solid rgba(255, 255, 255, 0.8);  
            }
        }
    }
    .icon {
        position: absolute;
        top: 1%;
        left: 1%;
        display: block;
        height: auto;
        width: 10%;
        z-index: 2;
    }
}
</style>